export default __webpack_public_path__ + "static/Difi.io_v4-03-bee7464d97e4a46ae630530beefca97f.jpg";